import React from 'react';
import styled from 'styled-components/native';

import Image from '@src/components/Image';

const Content = styled(Image)`
  width: 116px;
  height: 28px;
  resize-mode: contain;
`;

const Component: React.FC = () => (
  <Content source={require('@src/assets/images/logo_full_fa.png')} />
);

Component.displayName = 'LogoTitle';

export default Component;
